import "../css/bootstrap@3.3.7.min.css";
import "../css/bootstrap-table@1.11.0.min.css";

import "../css/uploadform.css";
import "../css/panel.css";
import "../css/webserver.css";
import "../js/libs/json2";
import { make_jobid } from "../js/createjobid";
import { fileupload } from "../js/upload";
import { run } from "../js/run";
import { StateTable } from "../js/state_table";
import { check } from "../js/check";
import { update } from "../js/state_update";
import { BtnToggler } from "../js/btnToggler";
import { scrollToAnchor } from "../js/scrollToAnchor";
// import { parseQuery } from "../js/parseQuery";
import { UNLOCK_SUBMIT_EVT } from "../js/constants";

$("header").load("./ajax/header.html");
$("footer").load("./ajax/footer.html");

var job;
var filename;
var id;
var timer;
//var count=0;
var json_str = [];
var row1 = {};
// var querys = parseQuery(),
//     jobId = querys.jobId;
var fingerprint = "rpa";
//var uid=checkCookies(fingerprint,json_str);
var uid = checkcookies();
//StateTable(json_str);
//update(uid);

function scrollToHistory() {
  scrollToAnchor("#task-records");
}

function checkcookies() {
  var user;
  $.ajax({
    url: "./php/cookies.php",
    method: "post",
    data: {
      cname: fingerprint,
    },
    async: false,
    success: function (r1) {
      //console.log(r1);
      user = r1;
      StateTable(json_str);
      update(user);
      // if (jobId) {
      //     scrollToHistory();
      // }
    },
    error: function (r1) {
      console.error(r1);
    },
  });
  return user;
}

function input(targetfile) {
  //var targetfile=document.getElementById("fileupload").value;
  var target = "";
  var uppath = new Array();
  uppath = targetfile.split("\\");
  var bar = $(".bar");
  var percent = $(".percent");
  var showimg = $("#showimg");
  var progress = $(".progress");
  var files = $(".files");
  var btn = $(".btn2 span");
  var action = "php/Fileupload.php?dir_name=";
  var jobid = String($.trim(make_jobid()));
  clear1();
  if (jobid != false) {
    action = action + jobid;
    fileupload(bar, percent, showimg, progress, files, btn, action);
    target = "output/" + jobid + "/" + uppath[uppath.length - 1];
    // console.log(target);
    id = jobid;
    job = "output/" + jobid + "/";
    filename = uppath[uppath.length - 1];
    //k=setInterval("circle('"+target+"',"+finish+")",5000);
    //circle("'"+target+"'",finish);
  }
}

function input2(content, callback) {
  var jobid = String($.trim(make_jobid()));
  id = jobid;
  $.ajax({
    method: "post",
    url: "php/run_text.php",
    data: "jobId=" + jobid + "&content=" + content,
    async: true,
    success: function (r1, r2, r3) {
      //console.log(r1);
      callback();
    },
    error: function (r1) {
      console.error("Fail to get example:", r1);
      $(window).trigger(UNLOCK_SUBMIT_EVT);
      //return "fail";
    },
  });
}
var $fileUpload = $("#fileupload");
$fileUpload.change(function () {
  var targetfile = document.getElementById("fileupload").value;
  input(targetfile);
});

$("#clear_sequence").click(function () {
  clear1(); //$("#textinput").val('');
  clear2();
});

$("#load_tab").click(function () {
  showexample("stage");
});

$("#submit").on("click", calculate);

function showexample(type) {
  $("#textinput").val("");
  clear2();
  $.ajax({
    method: "post",
    url: "php/get_example.php",
    data: "type=" + type,
    async: true,
    success: function (r1, r2, r3) {
      $("#textinput").val(r1);
    },
    error: function (r1) {
      console.error("Fail to get example:", r1);
      //return "fail";
    },
  });
  //document.getElementById("textinput").innerHTML=s;
}

function clear1() {
  $("#textinput").val("");
}

function clear2() {
  $("#progress-bar").width("0%");
  $("#progress-percent").html("0%");
  $("#input_name").remove();
  $fileUpload.clearFields();
  filename = undefined;
}

var submitToggler = new BtnToggler("#submit");
function calculate() {
  var form = document.forms["form1"];
  var level = form.level.value;
  var timeIntervalInput = form.time_intervals;
  if (!timeIntervalInput.checkValidity()) {
    alert("Time period of survival rate must > 0!");
    return;
  }
  var timeintervals = timeIntervalInput.value;
  var timeUnit = $(form["time-unit"]).val();
  var callback = function () {
    run(id, level, uid, timeintervals, timeUnit, function () {
      check(id, function () {
        update(uid);
      });
      scrollToHistory();
    });
  };
  var hasFile = $fileUpload.val();
  if (hasFile) {
    submitToggler.lock("Submitting...");
    $(window).one(UNLOCK_SUBMIT_EVT, function () {
      submitToggler.unlock();
    });
    callback();
  } else {
    var dataInput = $.trim($("#textinput").val());
    if (dataInput) {
      submitToggler.lock("Submitting...");
      $(window).one(UNLOCK_SUBMIT_EVT, function () {
        submitToggler.unlock();
      });
      input2(dataInput, callback);
    } else {
      alert("No data detected!");
    }
  }
}
